
export const routes = (id, unitLayoutID, hasAccess = false) => {
  const links = [
    { text: 'Overview', value: `/projects/${id}/layouts/${unitLayoutID}/` },
  ];
  if (hasAccess) {
    links.push(
      { text: 'Pictures', value: `/projects/${id}/layouts/${unitLayoutID}/pictures/` },
      { text: 'Documents', value: `/projects/${id}/layouts/${unitLayoutID}/documents/` },
      { text: 'Videos', value: `/projects/${id}/layouts/${unitLayoutID}/videos/` },
    );
  }
  return links;
};



// WEBPACK FOOTER //
// ./src/containers/Project/UnitLayout/navigations.js